/* Paint Glue theme — lightweight vanilla JS.
   Handles: mobile menu, FAQ (native <details>), AJAX add-to-cart, cart drawer,
   quantity steppers. No frameworks. */
(function () {
  "use strict";

  var money = function (cents) {
    try {
      return (cents / 100).toLocaleString("en-US", { style: "currency", currency: window.PG_CURRENCY || "USD" });
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  };

  var cartType = (window.PG_CART_TYPE || "drawer");
  var paintGlueColorMap = {
    "White": "#f7f3e8",
    "Beige": "#c9b891",
    "Tan": "#b69264",
    "Grey": "#8d8f8b",
    "0569 Fireplace Mantel": "#867f73",
    "0046 Valentino": "#835246",
    "0501 Calm Interlude": "#485559",
    "0430 Vegetarian": "#5f634f",
    "0208 Umber Style": "#ebe7dd",
    "0537 Dove’s Wing": "#e1dfd9",
    "0537 Dove's Wing": "#e1dfd9",
    "0530 Metro": "#d5d4d0",
    "0536 Subway": "#4f4e4c",
    "0482 Powdered Pool": "#c9d6d1",
    "0647 Zenith": "#557ea2",
    "0793 Motherland": "#bdb86c",
    "0126 Sauterne": "#d6bcb4",
    "0195 Mossy Shade": "#dad3c8",
    "0371 Fiorito": "#c1c1b1",
    "0490 Beacon Fog": "#9facad",
    "0037 Money Tree": "#c99780"
  };

  /* Real swatch image URLs are injected by cart-drawer.liquid via Liquid's
     asset_url filter (window.PG_SWATCH_URLS). theme.js is a static asset and
     cannot emit asset_url itself, so it reads that Liquid-provided map here.
     Falls back gracefully (returns "") when the map or key is absent. */
  function swatchImageUrl(name) {
    var map = window.PG_SWATCH_URLS;
    if (!map || !name) return "";
    var key = String(name).trim();
    if (map[key]) return map[key];
    var straight = key.replace(/’/g, "'");
    if (map[straight]) return map[straight];
    var curly = key.replace(/'/g, "’");
    if (map[curly]) return map[curly];
    return "";
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (char) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char];
    });
  }

  function getLineColorName(item) {
    if (item && Array.isArray(item.options_with_values)) {
      for (var i = 0; i < item.options_with_values.length; i += 1) {
        var option = item.options_with_values[i];
        if (option && String(option.name || "").toLowerCase() === "color") return option.value;
      }
    }
    if (item && Array.isArray(item.variant_options)) {
      for (var j = 0; j < item.variant_options.length; j += 1) {
        if (paintGlueColorMap[item.variant_options[j]]) return item.variant_options[j];
      }
    }
    if (item && item.variant_title) {
      var parts = String(item.variant_title).split(" / ");
      for (var k = 0; k < parts.length; k += 1) {
        if (paintGlueColorMap[parts[k]]) return parts[k];
      }
    }
    return "";
  }

  function cartColorSwatch(item) {
    var colorName = getLineColorName(item);
    var colorHex = paintGlueColorMap[colorName];
    var colorImage = swatchImageUrl(colorName);
    if (!colorName || (!colorHex && !colorImage)) return "";
    var chip;
    if (colorImage) {
      chip = '<span class="pg-line__swatch-chip pg-line__swatch-chip--image" style="--cart-swatch:' +
        escapeHtml(colorHex || "#f8f5ea") + ';background-image:url(' + encodeURI(colorImage) + ')"></span>';
    } else {
      chip = '<span class="pg-line__swatch-chip" style="--cart-swatch:' + escapeHtml(colorHex) + '"></span>';
    }
    return (
      '<div class="pg-line__swatch" aria-label="Selected color ' + escapeHtml(colorName) + '">' +
        chip +
        '<span><b>Color</b> ' + escapeHtml(colorName) + '</span>' +
      '</div>'
    );
  }

  /* ---------- Mobile menu ---------- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-menu-toggle]");
    if (toggle) {
      var nav = document.getElementById("pg-nav");
      if (nav) nav.classList.toggle("is-open");
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty-step]");
    if (!btn) return;
    var wrap = btn.closest(".pg-qty");
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(btn.getAttribute("data-qty-step"), 10);
    if (val < 1) val = 1;
    input.value = val;
  });

  /* ---------- PDP variant selection ---------- */
  document.addEventListener("change", function (e) {
    var sel = e.target.closest("[data-option-selector]");
    if (!sel) return;
    var form = sel.closest("form");
    if (!form) return;
    var variantSelect = form.querySelector("[data-variant-id]");
    if (!variantSelect) return;
    var chosen = Array.prototype.map.call(
      form.querySelectorAll("[data-option-selector]"),
      function (s) { return s.value.trim(); }
    ).join(" / ");
    Array.prototype.forEach.call(variantSelect.options, function (opt) {
      if (opt.textContent.trim() === chosen) variantSelect.value = opt.value;
    });
  });

  /* ---------- Cart drawer open/close ---------- */
  var drawer = document.getElementById("pg-cart-drawer");
  var overlay = document.getElementById("pg-cart-overlay");

  function openDrawer() {
    if (!drawer) return;
    hideSwatchPopup();
    hoverSwatch = null;
    drawer.classList.add("is-open");
    if (overlay) overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    if (overlay) overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  window.PaintGlueCart = { open: openDrawer, close: closeDrawer };

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-open]")) {
      // If drawer mode, intercept; otherwise allow navigation to /cart
      if (cartType === "drawer") {
        e.preventDefault();
        refreshDrawer().then(openDrawer);
      }
    }
    if (e.target.closest("[data-cart-close]") || e.target === overlay) closeDrawer();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[data-product-form]");
    if (!form) return;
    e.preventDefault();
    var submit = form.querySelector('[type="submit"]');
    var original = submit ? submit.innerHTML : "";
    if (submit) { submit.disabled = true; submit.innerHTML = "Adding…"; }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(serialize(form))
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.data;
        if (submit) { submit.innerHTML = "Added ✓"; }
        return refreshDrawer();
      })
      .then(function () {
        if (cartType === "drawer") openDrawer();
        else window.location.href = "/cart";
      })
      .catch(function (err) {
        if (submit) submit.innerHTML = "Unavailable";
        console.warn("Paint Glue cart error", err);
      })
      .finally(function () {
        setTimeout(function () { if (submit) { submit.disabled = false; submit.innerHTML = original; } }, 1400);
      });
  });

  function serialize(form) {
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    return { id: id ? id.value : null, quantity: qty ? parseInt(qty.value, 10) || 1 : 1 };
  }

  /* ---------- Refresh cart drawer + count from /cart.js ---------- */
  function refreshDrawer() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        renderDrawer(cart);
        return cart;
      })
      .catch(function () { /* offline / preview — ignore */ });
  }

  function updateCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? "inline-flex" : "none";
    });
  }

  function renderDrawer(cart) {
    var itemsEl = document.getElementById("pg-cart-items");
    var subtotalEl = document.getElementById("pg-cart-subtotal");
    if (!itemsEl) return;
    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="pg-drawer__empty">Your cart is empty.</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        var img = item.image ? '<img class="pg-line__img" src="' + item.image + '" alt="">' : '<div class="pg-line__img"></div>';
        var colorSwatch = cartColorSwatch(item);
        return (
          '<div class="pg-line" data-key="' + item.key + '">' +
            img +
            '<div>' +
              '<div class="pg-line__title">' + item.product_title + '</div>' +
              colorSwatch +
              '<div class="pg-line__meta">' + (item.variant_title && item.variant_title !== "Default Title" ? item.variant_title + " · " : "") + "Qty " + item.quantity +
                ' · <button type="button" data-cart-remove="' + item.key + '" style="background:none;border:none;text-decoration:underline;color:inherit;cursor:pointer;font-size:.78rem;padding:0">Remove</button>' +
              '</div>' +
            '</div>' +
            '<div class="pg-line__price">' + money(item.final_line_price) + '</div>' +
          '</div>'
        );
      }).join("");
    }
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
  }

  /* ---------- Remove from cart ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cart-remove]");
    if (!btn) return;
    e.preventDefault();
    var key = btn.getAttribute("data-cart-remove");
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); renderDrawer(cart); })
      .catch(function () {});
  });

  /* ---------- Init count on load ---------- */
  if (window.fetch) refreshDrawer();


  /* ---------- Visual color swatches ---------- */
  /* Locate the large preview panel for a swatch. Prefer the swatch's own form,
     but fall back to walking up ancestors (and finally the document) so hover /
     focus updates work even when the preview markup sits outside the form. */
  function findSwatchPreview(swatch, form) {
    if (form) {
      var inForm = form.querySelector("[data-swatch-preview]");
      if (inForm) return inForm;
    }
    var node = swatch ? swatch.parentElement : null;
    while (node && node !== document.body) {
      var found = node.querySelector("[data-swatch-preview]");
      if (found) return found;
      node = node.parentElement;
    }
    return document.querySelector("[data-swatch-preview]");
  }

  function setSwatchPreview(form, swatch) {
    if (!swatch) return;
    var preview = findSwatchPreview(swatch, form);
    if (!preview) return;
    var chip = preview.querySelector("[data-swatch-preview-chip]");
    var name = preview.querySelector("[data-swatch-preview-name]");
    var color = swatch.getAttribute("data-swatch-color") || "#f8f5ea";
    var label = swatch.getAttribute("data-option-value") || swatch.getAttribute("title") || "Selected color";
    var image = swatch.getAttribute("data-swatch-image") || swatchImageUrl(label);
    preview.style.setProperty("--preview-swatch", color);
    preview.classList.add("is-active");
    if (chip) {
      chip.style.backgroundColor = color;
      chip.style.backgroundImage = image ? "url(" + encodeURI(image) + ")" : "";
    }
    if (name) name.textContent = label;
  }

  /* The swatch group (grid) a given swatch belongs to; used to detect when the
     pointer/focus has truly left the group so we can restore the selection. */
  function swatchGroupOf(swatch) {
    return swatch.closest(".pg-swatch-grid") || swatch.closest("form");
  }

  /* Restore the preview to the currently selected swatch so browsing feels
     stable — leaving the group returns to what the customer actually picked. */
  function restoreSelectedPreview(swatch) {
    var form = swatch.closest("form");
    var group = swatchGroupOf(swatch);
    var selected = (group && group.querySelector('[data-swatch-option].is-selected:not(.pg-swatch--duplicate)')) ||
      (form && form.querySelector('[data-swatch-option].is-selected:not(.pg-swatch--duplicate)'));
    if (selected) setSwatchPreview(form, selected);
  }

  /* True when a pointer/focus transition stays inside the same swatch group. */
  function staysInGroup(swatch, relatedTarget) {
    var group = swatchGroupOf(swatch);
    return !!(relatedTarget && group && group.contains(relatedTarget));
  }

  /* ----- Centered popup preview -----
     One reusable, purely-visual node (created lazily, appended to <body>). It is
     pointer-events:none and aria-hidden, so it never traps clicks nor obscures
     the Add-to-Cart workflow, and screen readers keep using the swatch buttons /
     inline preview. It follows hover/focus/selection and hides on group-leave or
     Escape. */
  var swatchPopup = null;
  function ensureSwatchPopup() {
    if (swatchPopup) return swatchPopup;
    var el = document.createElement("div");
    el.className = "pg-swatch-popup";
    el.setAttribute("aria-hidden", "true");
    el.innerHTML =
      '<span class="pg-swatch-popup__chip" data-popup-chip></span>' +
      '<span class="pg-swatch-popup__label" data-popup-label></span>';
    document.body.appendChild(el);
    swatchPopup = el;
    return el;
  }
  function showSwatchPopup(swatch) {
    if (!swatch) return;
    var color = swatch.getAttribute("data-swatch-color") || "#f8f5ea";
    var label = swatch.getAttribute("data-option-value") || swatch.getAttribute("title") || "Selected color";
    var image = swatch.getAttribute("data-swatch-image") || swatchImageUrl(label);
    var el = ensureSwatchPopup();
    var chip = el.querySelector("[data-popup-chip]");
    var lab = el.querySelector("[data-popup-label]");
    if (chip) {
      chip.style.backgroundColor = color;
      chip.style.backgroundImage = image ? "url(" + encodeURI(image) + ")" : "";
    }
    if (lab) lab.textContent = label;
    el.classList.add("is-visible");
  }
  function hideSwatchPopup() {
    if (swatchPopup) swatchPopup.classList.remove("is-visible");
  }

  document.addEventListener("click", function (e) {
    var swatch = e.target.closest("[data-swatch-option]");
    if (!swatch) return;
    var form = swatch.closest("form");
    if (!form) return;
    var index = swatch.getAttribute("data-option-index");
    var value = swatch.getAttribute("data-option-value");
    var select = form.querySelector('[data-option-selector][data-option-index="' + index + '"]');
    if (!select) return;
    select.value = value;
    select.dispatchEvent(new Event("change", { bubbles: true }));
    form.querySelectorAll('[data-swatch-option][data-option-index="' + index + '"]').forEach(function (btn) {
      var selected = btn.getAttribute("data-option-value") === value;
      btn.classList.toggle("is-selected", selected);
      btn.setAttribute("aria-pressed", selected ? "true" : "false");
    });
    setSwatchPreview(form, swatch);
    showSwatchPopup(swatch);
  });

  /* Pointer-driven show/hide. Uses mousemove/pointermove/pointerover (not just
     mouseover) so it fires on real hover AND synthetic CDP mouseMoved events,
     which emit mousemove rather than mouseover. A tracked current swatch avoids
     redundant updates, updates image+label while moving swatch→swatch, and hides
     only once the pointer leaves the whole swatch group (independent of the
     unreliable relatedTarget). */
  var hoverSwatch = null;
  function pointerUpdateSwatch(e) {
    var target = e.target;
    var swatch = target && target.closest ? target.closest("[data-swatch-option]") : null;
    if (swatch && !swatch.classList.contains("pg-swatch--duplicate")) {
      if (swatch !== hoverSwatch) {
        hoverSwatch = swatch;
        setSwatchPreview(swatch.closest("form"), swatch);
        showSwatchPopup(swatch);
      }
      return;
    }
    if (hoverSwatch) {
      var group = swatchGroupOf(hoverSwatch);
      if (!group || !group.contains(target)) {
        restoreSelectedPreview(hoverSwatch);
        hideSwatchPopup();
        hoverSwatch = null;
      }
    }
  }
  document.addEventListener("mousemove", pointerUpdateSwatch);
  document.addEventListener("pointermove", pointerUpdateSwatch);
  document.addEventListener("pointerover", pointerUpdateSwatch);
  document.addEventListener("mouseover", pointerUpdateSwatch);

  document.addEventListener("focusin", function (e) {
    var swatch = e.target.closest("[data-swatch-option]");
    if (!swatch || swatch.classList.contains("pg-swatch--duplicate")) return;
    setSwatchPreview(swatch.closest("form"), swatch);
    showSwatchPopup(swatch);
  });

  document.addEventListener("focusout", function (e) {
    var swatch = e.target.closest("[data-swatch-option]");
    if (!swatch) return;
    if (staysInGroup(swatch, e.relatedTarget)) return;
    restoreSelectedPreview(swatch);
    hideSwatchPopup();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { hideSwatchPopup(); hoverSwatch = null; }
  });

  document.addEventListener("change", function (e) {
    var select = e.target.closest("[data-option-selector]");
    if (!select) return;
    var form = select.closest("form");
    if (!form) return;
    var index = select.getAttribute("data-option-index");
    form.querySelectorAll('[data-swatch-option][data-option-index="' + index + '"]').forEach(function (btn) {
      var selected = btn.getAttribute("data-option-value") === select.value;
      btn.classList.toggle("is-selected", selected);
      btn.setAttribute("aria-pressed", selected ? "true" : "false");
      if (selected) setSwatchPreview(form, btn);
    });
  });

  /* Paint the small product-swatch chips with actual swatch imagery when
     available (keyed by the swatch's color value). Hex background remains as
     the fallback for any color without an uploaded image. */
  function applySwatchImages(scope) {
    (scope || document).querySelectorAll("[data-swatch-option]").forEach(function (swatch) {
      var chip = swatch.querySelector(".pg-swatch__color");
      if (!chip) return;
      var label = swatch.getAttribute("data-option-value") || swatch.getAttribute("title") || "";
      var image = swatch.getAttribute("data-swatch-image") || swatchImageUrl(label);
      if (!image) return;
      chip.style.backgroundImage = "url(" + encodeURI(image) + ")";
      chip.classList.add("pg-swatch__color--image");
    });
  }
  /* Hide only *exact* duplicate swatch buttons (same option index + same value
     within one form). A literal repeat points at the identical variant value,
     so the first button still selects it — this never removes a distinct color
     and never touches the underlying <select>, so variant selection is intact.
     Duplicates arising from genuinely distinct Shopify variant values are left
     visible on purpose (removing them could break selection). */
  function dedupeSwatches(scope) {
    (scope || document).querySelectorAll("form").forEach(function (form) {
      var seen = {};
      form.querySelectorAll("[data-swatch-option]").forEach(function (swatch) {
        var index = swatch.getAttribute("data-option-index") || "";
        var value = (swatch.getAttribute("data-option-value") || "").trim().replace(/’/g, "'").toLowerCase();
        var key = index + "::" + value;
        if (seen[key]) {
          swatch.classList.add("pg-swatch--duplicate");
          swatch.setAttribute("aria-hidden", "true");
          swatch.setAttribute("tabindex", "-1");
        } else {
          seen[key] = true;
        }
      });
    });
  }
  dedupeSwatches(document);
  applySwatchImages(document);

  document.querySelectorAll("form").forEach(function (form) {
    var selectedSwatch = form.querySelector("[data-swatch-option].is-selected:not(.pg-swatch--duplicate)");
    if (selectedSwatch) setSwatchPreview(form, selectedSwatch);
  });

  /* ---------- PDP price unit label ---------- */
  /* The coating is sold per gallon, so annotate the product price to say so.
     PDP-only (`.pg-pdp__price` renders only on the product page), idempotent,
     and appended as a separate node — no pricing/variant logic runs on this
     element, and cart / line-item prices are untouched. */
  (function annotatePdpPrice() {
    var price = document.querySelector(".pg-pdp__price");
    if (!price || price.querySelector(".pg-pdp__price-unit")) return;
    var unit = document.createElement("span");
    unit.className = "pg-pdp__price-unit";
    unit.textContent = "/ gallon";
    price.appendChild(unit);
  })();

  /* ---------- Home photo color visualizer (client-side only) ---------- */
  /* Injected via JS on the product page only (gated by the color-swatch grid,
     which renders on the PDP). Everything happens in-browser: the uploaded photo
     never leaves the device — no network request, no localStorage/cookies. A
     separate mask canvas records brushed coverage independent of color, so
     changing color or opacity re-tints instantly without repainting. */
  function initVisualizer() {
    var grid = document.querySelector(".pg-swatch-grid");
    if (!grid) return;                                    // product page only
    if (document.getElementById("pg-visualizer")) return; // never duplicate

    // Build the color dropdown, de-duping apostrophe variants by normalized label.
    var colorEntries = [];
    var seenColor = {};
    Object.keys(paintGlueColorMap).forEach(function (name) {
      var norm = name.replace(/’/g, "'").toLowerCase();
      if (seenColor[norm]) return;
      seenColor[norm] = true;
      colorEntries.push({ name: name, hex: paintGlueColorMap[name] });
    });
    var optionsHtml = colorEntries.map(function (c) {
      return '<option value="' + escapeHtml(c.name) + '" data-hex="' + escapeHtml(c.hex) + '">' +
        escapeHtml(c.name) + "</option>";
    }).join("");

    var section = document.createElement("section");
    section.id = "pg-visualizer";
    section.className = "pg-visualizer";
    section.innerHTML =
      '<div class="pg-visualizer__head">' +
        '<h2 class="pg-visualizer__title">Visualize it on your home</h2>' +
        '<p class="pg-visualizer__note">Your photo stays in your browser and is not uploaded.</p>' +
      '</div>' +
      '<div class="pg-visualizer__body">' +
        '<div class="pg-visualizer__controls">' +
          '<label class="pg-visualizer__field"><span>1. Upload a photo of your home</span>' +
            '<input type="file" accept="image/*" data-viz-file></label>' +
          '<label class="pg-visualizer__field"><span>2. Choose a Top Coat color</span>' +
            '<select data-viz-color>' + optionsHtml + '</select></label>' +
          '<div class="pg-visualizer__field"><span>3. Brush the siding or wall area</span>' +
            '<div class="pg-visualizer__tools">' +
              '<button type="button" class="pg-btn pg-btn--outline is-active" data-viz-mode="paint">Brush</button>' +
              '<button type="button" class="pg-btn pg-btn--outline" data-viz-mode="erase">Eraser</button>' +
            '</div></div>' +
          '<label class="pg-visualizer__range"><span>Brush size</span>' +
            '<input type="range" min="8" max="120" value="40" data-viz-size></label>' +
          '<label class="pg-visualizer__range"><span>Overlay opacity</span>' +
            '<input type="range" min="10" max="100" value="65" data-viz-opacity></label>' +
          '<p class="pg-visualizer__tip">Zoom in, then brush the siding or wall area.</p>' +
          '<div class="pg-visualizer__range"><span>Zoom photo</span>' +
            '<div class="pg-visualizer__zoomctl">' +
              '<button type="button" class="pg-btn pg-btn--outline" data-viz-zoom-out aria-label="Zoom out">−</button>' +
              '<input type="range" min="100" max="400" step="10" value="100" data-viz-zoom-range aria-label="Zoom level">' +
              '<button type="button" class="pg-btn pg-btn--outline" data-viz-zoom-in aria-label="Zoom in">+</button>' +
              '<button type="button" class="pg-btn pg-btn--outline" data-viz-zoom-fit>Fit</button>' +
            '</div></div>' +
          '<div class="pg-visualizer__tools">' +
            '<button type="button" class="pg-btn pg-btn--outline" data-viz-reset>Clear paint</button>' +
            '<button type="button" class="pg-btn pg-btn--primary" data-viz-download disabled>Download preview</button>' +
          '</div>' +
        '</div>' +
        '<div class="pg-visualizer__stage" data-viz-stage>' +
          '<div class="pg-visualizer__placeholder" data-viz-placeholder>Upload a photo of your home to begin. Then brush over the walls to preview your color.</div>' +
          '<div class="pg-visualizer__zoom" data-viz-zoom>' +
            '<canvas class="pg-visualizer__canvas pg-visualizer__canvas--base" data-viz-base></canvas>' +
            '<canvas class="pg-visualizer__canvas pg-visualizer__canvas--overlay" data-viz-overlay></canvas>' +
          '</div>' +
        '</div>' +
      '</div>';

    /* Place the visualizer directly beneath the product pictures (left media
       column of the PDP grid), opposite the description/purchase area. Falls
       back to sitting after the product form if the PDP media layout isn't
       found, so the tool still appears on non-standard templates. */
    var gallery = document.querySelector(".pg-pdp__gallery-main");
    var pdp = gallery && gallery.closest(".pg-pdp");
    if (gallery && pdp) {
      var col = gallery;
      while (col.parentElement && col.parentElement !== pdp) col = col.parentElement;
      if (col && col.parentElement === pdp && col !== gallery) {
        col.appendChild(section); // media column is a wrapper — stack under it
      } else {
        var thumbs = pdp.querySelector(".pg-pdp__thumbs");
        var afterEl = (thumbs && thumbs.parentElement === pdp) ? thumbs : (col || gallery);
        pdp.insertBefore(section, afterEl.nextSibling);
        section.classList.add("pg-visualizer--grid-left");
      }
    } else {
      var anchor = grid.closest("form[data-product-form]") || grid.closest("form") || grid;
      anchor.parentNode.insertBefore(section, anchor.nextSibling);
    }

    var fileInput = section.querySelector("[data-viz-file]");
    var colorSelect = section.querySelector("[data-viz-color]");
    var sizeInput = section.querySelector("[data-viz-size]");
    var opacityInput = section.querySelector("[data-viz-opacity]");
    var resetBtn = section.querySelector("[data-viz-reset]");
    var downloadBtn = section.querySelector("[data-viz-download]");
    var placeholder = section.querySelector("[data-viz-placeholder]");
    var baseCanvas = section.querySelector("[data-viz-base]");
    var overlayCanvas = section.querySelector("[data-viz-overlay]");
    var zoomWrap = section.querySelector("[data-viz-zoom]");
    var zoomRange = section.querySelector("[data-viz-zoom-range]");
    var zoomIn = section.querySelector("[data-viz-zoom-in]");
    var zoomOut = section.querySelector("[data-viz-zoom-out]");
    var zoomFit = section.querySelector("[data-viz-zoom-fit]");
    var baseCtx = baseCanvas.getContext("2d");
    var overlayCtx = overlayCanvas.getContext("2d");
    var maskCanvas = document.createElement("canvas");
    var maskCtx = maskCanvas.getContext("2d");

    var img = null;
    var mode = "paint";
    var painting = false;
    var lastPt = null;
    var zoom = 100;
    var MAX_W = 1200;

    /* Zoom scales the canvas wrapper's layout width inside the overflow:auto
       stage (not a CSS transform), so the stage becomes scrollable/pannable and
       — because pointer mapping derives from getBoundingClientRect() — brush and
       eraser coordinates keep mapping correctly at any zoom. Purely a display
       change: the underlying canvas pixels (and downloads) are unaffected. */
    function applyZoom() {
      zoom = Math.max(100, Math.min(400, zoom));
      zoomWrap.style.width = zoom + "%";
      if (zoomRange) zoomRange.value = zoom;
    }

    function trySelectColor(label) {
      var norm = String(label).replace(/’/g, "'").toLowerCase();
      Array.prototype.forEach.call(colorSelect.options, function (opt) {
        if (opt.value.replace(/’/g, "'").toLowerCase() === norm) colorSelect.value = opt.value;
      });
    }
    function currentColor() {
      var opt = colorSelect.options[colorSelect.selectedIndex];
      return (opt && opt.getAttribute("data-hex")) || paintGlueColorMap[colorSelect.value] || "#cccccc";
    }

    // Seed the dropdown from the currently selected product swatch when present.
    var selectedSwatch = document.querySelector('[data-swatch-option].is-selected:not(.pg-swatch--duplicate)');
    if (selectedSwatch && selectedSwatch.getAttribute("data-option-value")) {
      trySelectColor(selectedSwatch.getAttribute("data-option-value"));
    }

    function renderOverlay() {
      var w = overlayCanvas.width, h = overlayCanvas.height;
      if (!w || !h) return;
      overlayCtx.clearRect(0, 0, w, h);
      overlayCtx.globalCompositeOperation = "source-over";
      overlayCtx.drawImage(maskCanvas, 0, 0);
      overlayCtx.globalCompositeOperation = "source-in";
      overlayCtx.fillStyle = currentColor();
      overlayCtx.fillRect(0, 0, w, h);
      overlayCtx.globalCompositeOperation = "source-over";
      overlayCanvas.style.opacity = (parseInt(opacityInput.value, 10) || 65) / 100;
    }

    function setupCanvases(image) {
      var w = image.naturalWidth || image.width;
      var h = image.naturalHeight || image.height;
      if (!w || !h) return;
      var scale = Math.min(1, MAX_W / w);
      var cw = Math.round(w * scale), ch = Math.round(h * scale);
      [baseCanvas, overlayCanvas, maskCanvas].forEach(function (c) { c.width = cw; c.height = ch; });
      baseCtx.clearRect(0, 0, cw, ch);
      baseCtx.drawImage(image, 0, 0, cw, ch);
      maskCtx.clearRect(0, 0, cw, ch);
      section.classList.add("is-ready");
      zoom = 100;
      applyZoom();
      renderOverlay();
    }

    fileInput.addEventListener("change", function () {
      var file = fileInput.files && fileInput.files[0];
      if (!file) return;
      var url = URL.createObjectURL(file);
      var image = new Image();
      image.onload = function () {
        URL.revokeObjectURL(url);
        img = image;
        setupCanvases(image);
        downloadBtn.disabled = false;
      };
      image.onerror = function () { URL.revokeObjectURL(url); };
      image.src = url;
    });

    function pointFromEvent(e) {
      var rect = overlayCanvas.getBoundingClientRect();
      var sx = overlayCanvas.width / (rect.width || 1);
      var sy = overlayCanvas.height / (rect.height || 1);
      return { x: (e.clientX - rect.left) * sx, y: (e.clientY - rect.top) * sy };
    }
    function brushRadius() {
      var rect = overlayCanvas.getBoundingClientRect();
      var sx = overlayCanvas.width / (rect.width || 1);
      return ((parseInt(sizeInput.value, 10) || 40) * sx) / 2;
    }
    function stroke(from, to) {
      var r = brushRadius();
      maskCtx.globalCompositeOperation = (mode === "erase") ? "destination-out" : "source-over";
      maskCtx.strokeStyle = "rgba(0,0,0,1)";
      maskCtx.fillStyle = "rgba(0,0,0,1)";
      maskCtx.lineJoin = "round";
      maskCtx.lineCap = "round";
      maskCtx.lineWidth = r * 2;
      if (from) {
        maskCtx.beginPath();
        maskCtx.moveTo(from.x, from.y);
        maskCtx.lineTo(to.x, to.y);
        maskCtx.stroke();
      }
      maskCtx.beginPath();
      maskCtx.arc(to.x, to.y, r, 0, Math.PI * 2);
      maskCtx.fill();
      maskCtx.globalCompositeOperation = "source-over";
      renderOverlay();
    }

    overlayCanvas.addEventListener("pointerdown", function (e) {
      if (!img) return;
      e.preventDefault();
      painting = true;
      try { overlayCanvas.setPointerCapture(e.pointerId); } catch (_) {}
      lastPt = pointFromEvent(e);
      stroke(null, lastPt);
    });
    overlayCanvas.addEventListener("pointermove", function (e) {
      if (!painting) return;
      e.preventDefault();
      var p = pointFromEvent(e);
      stroke(lastPt, p);
      lastPt = p;
    });
    function endStroke() { painting = false; lastPt = null; }
    overlayCanvas.addEventListener("pointerup", endStroke);
    overlayCanvas.addEventListener("pointercancel", endStroke);

    colorSelect.addEventListener("change", renderOverlay);
    opacityInput.addEventListener("input", renderOverlay);
    zoomRange.addEventListener("input", function () { zoom = parseInt(zoomRange.value, 10) || 100; applyZoom(); });
    zoomIn.addEventListener("click", function () { zoom += 25; applyZoom(); });
    zoomOut.addEventListener("click", function () { zoom -= 25; applyZoom(); });
    zoomFit.addEventListener("click", function () { zoom = 100; applyZoom(); });
    resetBtn.addEventListener("click", function () {
      if (!maskCanvas.width) return;
      maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
      renderOverlay();
    });
    section.querySelectorAll("[data-viz-mode]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        mode = btn.getAttribute("data-viz-mode");
        section.querySelectorAll("[data-viz-mode]").forEach(function (b) {
          b.classList.toggle("is-active", b === btn);
        });
      });
    });
    downloadBtn.addEventListener("click", function () {
      if (!img) return;
      var w = baseCanvas.width, h = baseCanvas.height;
      var out = document.createElement("canvas");
      out.width = w; out.height = h;
      var octx = out.getContext("2d");
      octx.drawImage(baseCanvas, 0, 0);
      octx.globalAlpha = (parseInt(opacityInput.value, 10) || 65) / 100;
      octx.drawImage(overlayCanvas, 0, 0);
      octx.globalAlpha = 1;
      var href;
      try { href = out.toDataURL("image/png"); } catch (err) { return; }
      var a = document.createElement("a");
      a.href = href;
      a.download = "paint-glue-preview.png";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });

    // Keep the visualizer color in sync when a product swatch is picked. This is
    // a passive listener — it never alters variant selection or the cart.
    document.addEventListener("click", function (e) {
      var sw = e.target.closest("[data-swatch-option]");
      if (!sw || sw.classList.contains("pg-swatch--duplicate")) return;
      var v = sw.getAttribute("data-option-value");
      if (!v) return;
      trySelectColor(v);
      renderOverlay();
    });
  }
  initVisualizer();

})();
